// Lightweight click tracking for the NEXA/LendingPad handoff.
// Fires a fire-and-forget beacon to our backend so we can report on
// how many people click through, from where, and via which campaign.

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function genId() {
  try {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  } catch (e) {
    /* noop */
  }
  return `c_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * Record an "Apply Now" handoff click.
 * @param {string} source  - which button was clicked (e.g. "apply-hero-cta")
 * @param {string} destination - the outbound URL
 * @returns {string} the generated click_id
 */
export function trackApplyClick(source, destination, mloSlug) {
  const clickId = genId();
  try {
    const params = new URLSearchParams(window.location.search);
    const payload = {
      click_id: clickId,
      source,
      destination,
      mlo_slug: mloSlug || null,
      referrer: document.referrer || null,
      landing_path: window.location.pathname + window.location.search,
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_term: params.get("utm_term"),
      utm_content: params.get("utm_content"),
      screen: `${window.innerWidth}x${window.innerHeight}`,
    };

    const url = `${API}/track/apply-click`;
    const body = JSON.stringify(payload);

    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }

    // Optional GA4 event if gtag is present on the page.
    if (typeof window.gtag === "function") {
      window.gtag("event", "apply_click", { source, destination, click_id: clickId });
    }
  } catch (e) {
    /* never block the handoff */
  }
  return clickId;
}
